import React from 'react'
import { motion } from "framer-motion";
import NavigationButton from './NavigationButton';

const RightImage = () => {
  return (
    <motion.div initial={{ opacity: 0}} whileInView={{ opacity: 1}}  transition={{ delay: 0.2, duration: 2}} >
            <section id="right-image" className="section-image-bg section-full-frame">
                <div className="row section-full-frame d-flex justify-content-between align-items-center section-diviser">
                    <div className="col-sm-12 d-flex justify-content-center align-items-center">
                        <NavigationButton mySelector="#main-image" myIcon="chevron-up" hasMargin={false}/>
                    </div>
                    <div className="col-sm-12 col-md-6 d-flex flex-column justify-content-between align-items-center section-with-image">
                        <article>
                          <h2 className="title mb-5 text-left display-5">One house, two bedrooms</h2>
                          <p>Inside, the house invites you to linger, either in the living room or in one of the two beautiful master bedrooms. The abundance of natural wood and its permanent dialogue with the mineral beige-earth of the microcement (reminiscent of the color of the stone in the back) create an atmosphere of warmth and cosiness that intensifies when the fireplace is on. Black metal details add a crispy touch of sophistication. The meticulously designed spiral staircase becomes a sculptural element in the living room.  </p>
                        </article>
                    </div>
                    <div className="col-sm-12 col-md-6 section-with-image">
                        <img className="img-fluid rounded-5" style={{ maxHeight: '600px' }} src="https://images.squarespace-cdn.com/content/v1/63566161d13f2053d113aa4a/c19ca321-4a17-4369-b44d-180c6ee3abf2/MARTA_BRANDAO_AROUCA_LOW-38.jpg" alt="bedroom" />
                    </div>
                    <div className="col-sm-12 d-flex justify-content-center">
                        <NavigationButton mySelector="#left-image" myIcon="chevron-down" hasMargin={true}/>
                    </div>
                </div>
            </section>
        </motion.div>
  )
}

export default RightImage
